import Route from '@ember/routing/route';

export default class AuthenticatedPslfRecommendationsRoute extends Route {
  queryParams = {
    recommendation: { refreshModel: false, replace: false },
  };
}
